import { useCallback, useRef } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE } from '../../controller/Controller';

export const useShareRecommendedUsersAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const recommendedUsersCountRef = useRef(0);

	const addRecommendedUserCount = useCallback(() => {
		recommendedUsersCountRef.current += 1;
	}, []);

	const sendRecommendedUsersCount = useCallback(() => {
		const currentCount = recommendedUsersCountRef.current;
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				actionSubject: 'shareRecommendedUsers',
				action: 'usedRecommendedUsers',
				source: SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE,
				attributes: {
					recommendedUsersCount: currentCount,
				},
			},
		}).fire();
	}, [createAnalyticsEvent]);

	return { addRecommendedUserCount, sendRecommendedUsersCount };
};
